import React from 'react';
import { Chip } from '@mui/material';
import { WarningCircle } from '@phosphor-icons/react';

export function isPotentialSpam(entry) {
  return entry?.spamStatus === 'suspected';
}

/** True when a cleared enquiry still has a CRM or Mailchimp step that did not finish. */
export function hasFailedDeferredStep(entry) {
  const steps = entry?.deferredSteps;
  if (!steps || entry?.spamStatus !== 'clear') return false;
  return Object.values(steps).some((step) => step?.status === 'failed');
}

function PotentialSpamChip({ sx }) {
  return (
    <Chip
      size="small"
      color="warning"
      variant="outlined"
      icon={<WarningCircle size={14} weight="bold" />}
      label="Potential spam"
      sx={{
        color: 'warning.dark',
        borderColor: 'warning.main',
        fontWeight: 600,
        '& .MuiChip-icon': { color: 'warning.dark' },
        ...sx,
      }}
    />
  );
}

export default PotentialSpamChip;
